import {
  isPossiblePhoneNumber,
  parsePhoneNumber,
} from 'react-phone-number-input';
import {
  COUNTRY_ISO2_TO_3,
  COUNTRY_ISO3_TO_2,
} from '../constants/countries.constants';

const regNumberWithPlus = /^\+{1}[0-9/]+$/;

const isValidPhoneNumber = (phone) => isPossiblePhoneNumber(phone);
const isNumberWithPlus = (number) => regNumberWithPlus.test(number);

const isValidEmail = (email) => {
  const regex = /\S+@\S+\.\S+/;
  return regex.test(email);
};

const isValidName = (name) => name && name.length > 1 && name.length < 100;

const isEmpty = (val) => val === undefined || val == null || val.length <= 0;

const isValidPassword = (password) => {
  const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
  return regex.test(password);
};

const isValidDateOfBirth = (date) => {
  return !!date;
};

const isValidFullName = (fullName) => {
  const words = fullName.valueOf().split(' ');
  return (
    fullName && fullName.length > 3 && words.length > 1 && fullName.length < 100
  );
};

const isPositiveNumber = (number) => {
  const regex = /^[0-9]+$/;
  return regex.test(number) && number > 0;
};

export const formUtils = {
  isValidPhoneNumber,
  isNumberWithPlus,
  isValidEmail,
  isValidPassword,
  isValidName,
  isValidDateOfBirth,
  isValidFullName,
  isPositiveNumber,
  isEmpty,
};

export const onEnterKeyClick = (ev, calllback) => {
  if (ev.keyCode === 13) {
    calllback(ev);
  }
};

export const objectFlip = (obj) =>
  Object.entries(obj).reduce((ret, entry) => {
    const [key, value] = entry;
    // eslint-disable-next-line no-param-reassign
    ret[value] = key;
    return ret;
  }, {});

export const getControversalISOCode = (code) => {
  if (code.length > 2) {
    return COUNTRY_ISO3_TO_2[code.toUpperCase()];
  }
  return COUNTRY_ISO2_TO_3[code.toUpperCase()];
};

export const getISO3AlphaCodeFromPhoneNumber = (phone) =>
  getControversalISOCode(parsePhoneNumber(phone).country);
